<template>
  <div id="Header" class="app-header-component">
    <header class="header header-transparent uk-light"
            uk-sticky="top:0 ; cls-active:header-sticky ; cls-inactive: uk-light2">
      <div class="container position-relative">
        <nav uk-navbar>
          <!-- left Side Content -->
          <div class="uk-navbar-left">
            <span class="btn-mobile" uk-toggle="target: #wrapper ; cls: mobile-active"/>
            <!-- logo -->
            <router-link :to="{ name: 'user.index' }" class="logo">
              <img :src="loginLogo" alt=""/>
              <div class="responsive"/>
            </router-link>

            <ProviderLinks :is-azal="isAzal" class="mobile-hidden"/>
          </div>

          <!--  Right Side Content   -->

          <div class="uk-navbar-right">
            <!-- SEARCH INPUT -->
            <div class="header-search-area mobile-hidden">
              <searching
                :force-show-search="true"
                :compact-mode="true"
                :loading="isFirstLoad && dashboardLoading"
                @searchFor="searchResults"
              />
            </div>
            <!-- Online Users: masaüstünde metin, tablet/mobilde ikon (header.scss 960px) -->
            <p v-if="onlineUsers.length && !hideOnlineUser" class="online" style="cursor: pointer"
               @click="showUser()">
              <i class="uil-users-alt"/>
              {{ onlineUserCount }} {{ $t("home.Person_Online") }}
            </p>
            <div class="header-widget">
              <!-- Anzera Power -->
              <div v-if="$roleCount() > 1" class="header-widget-icon anzera-chatbot-header-icon">
                <AnzeraChatBot/>
              </div>
              <!-- Online Users (tablet ve mobilde ikon) -->
              <a v-if="!hideOnlineUser" class="header-widget-icon online-users-icon" style="cursor: pointer"
                 @click="showUser()">
                <i class="uil-users-alt"/>
                <span v-if="onlineUsers.length > 0" class="online-indicator"/>
              </a>


              <!-- Anzera Life Dropdown (mobilde gizli) -->
              <AnzeraLifeDropdown class="ml-4 mobile-hidden"/>

              <a v-if="superAdmin() && superAdminToken" :uk-tooltip="`title: Kullanıcı Sayfasından çıkış yap`"
                 class="header-widget-icon mobile-hidden" style="color: red" @click="leaveFromUser()">
                <i class="uil-eye"></i>
              </a>

              <!-- Notification Dropdown -->
              <NotificationDropdown ref="notificationDropdown" :format-date="fixDateToNow"
                                    :notification-count="notificationCount" :notification-items="notificationItems"/>

              <!-- Message Notification Dropdown -->
              <message-notification-dropdown ref="messageRefs" :format-date-function="fixDateToNow" :is-chat-disabled="isChatDisabled"
                                             :item-count="itemCount" :message-items="messageItems"
                                             @message-click="(item) => closeDropdown('User.messages', 'messageRefs', item)"
                                             @see-all-click="closeDropdown('User.messages', 'messageRefs')"/>

              <!-- Language Component (mobilde gizli, ProfileDropdown icinde gorunur) -->
              <LanguageSelector class="mobile-hidden"/>

              <!-- Profile Dropdown -->
              <ProfileDropdown ref="profileDropdown" :user-info="userInfo" @logout="onLogout"
              />
            </div>
          </div>
        </nav>

      </div>
      <!-- container  / End -->
    </header>

    <OnlineUsersModal ref="onlineUsersModal" :company="company" :online-users="onlineUsers" :user-info="userInfo"/>
  </div>
</template>

<script>
import { LOGOUT } from "@/core/services/store/auth.module";
import _ from "lodash";
import moment from "moment";
import "moment/locale/fr";
import "moment/locale/es";
import "moment/locale/az";
import "moment/locale/tr";
import "moment/locale/en-gb";
import store from "@/core/services/index";
import { GET_ITEMS } from "@/core/services/store/REST.module";
import EventBus from "@/view/components/event-bus";
import axios from "axios";
import company_module, {
  GET_SELF as COMPANY_GET_SELF,
  MODULE_NAME as COMPANY_MODULE_NAME,
  SELF as COMPANY_SELF,
  SELF_URL as COMPANY_SELF_URL,
  SET_ONLINE_USERS,
} from "@/core/services/store/company.module";

import notification_module, {
  COUNT as NOTIFICATION_COUNT,
  GET_COUNT as NOTIFICATION_GET_COUNT,
  ITEMS as NOTIFICATION_ITEMS,
  GET_ITEMS as NOTIFICATION_GET_ITEMS,
  MODULE_NAME as NOTIFICATION_MODULE_NAME,
} from "@/core/services/store/notification.module";

import Echo from "laravel-echo";

window.io = require("socket.io-client");
import SecureLS from "secure-ls";

const ls = new SecureLS({ encodingType: "aes", isCompression: true });
import {
  subCompany,
  getSubCompanyId,
  getInitialSubDomainId,
} from "@/core/services/store.js";
import { integrationMixin } from "@/core/mixin/integration.mixin";
import LanguageSelector from "@/view/components/LanguageSelector.vue";
import MessageNotificationDropdown from "@/view/components/notification/MessageNotificationDropdown.vue";
import AnzeraLifeDropdown from "@/view/components/AnzeraLifeDropdown.vue";
import AnzeraChatBot from "@/view/components/chatbot/AnzeraChatBot.vue";
import OnlineUsersModal from "@/view/layouts/user/components/OnlineUsersModal.vue";
import NotificationDropdown from "@/view/layouts/shared/components/NotificationDropdown.vue";
import ProfileDropdown from "@/view/layouts/user/components/ProfileDropdown.vue";
import ProviderLinks from "@/view/layouts/user/components/ProviderLinks.vue";
import Searching from "@/view/components/index/Searching.vue";

export default {
  name: "Header",
  mixins: [integrationMixin],
  components: {
    LanguageSelector,
    AnzeraLifeDropdown,
    AnzeraChatBot,
    MessageNotificationDropdown,
    OnlineUsersModal,
    NotificationDropdown,
    ProfileDropdown,
    ProviderLinks,
    Searching,
  },
  data() {
    return {
      subCompany: subCompany,

      onlineUsers: [],
      superAdminToken: null,
      messagesUrl: "api/user-messages",
      messagesCountUrl: "api/user-messages-count",
      messageItems: [],
      itemCount: 0,
      isFirstLoad: false,
      dashboardLoading: false,
    };
  },
  beforeDestroy() {
    if (window.Echo && this.userInfo?.company_id) {
      window.Echo.leave(`online-users-${this.userInfo.company_id}`);
    }
  },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(COMPANY_MODULE_NAME, company_module);
    registerStoreModule(NOTIFICATION_MODULE_NAME, notification_module);
  },
  computed: {
    onlineUserCount() {
      return this.onlineUsers.length;
    },
    user_header() {
      return JSON.parse(this.secureLocalStorage("user"));
    },
    notificationCount() {
      return store.getters[
      NOTIFICATION_MODULE_NAME + "/" + NOTIFICATION_COUNT
          ];
    },
    notificationItems() {
      return store.getters[
      NOTIFICATION_MODULE_NAME + "/" + NOTIFICATION_ITEMS
          ];
    },
    company() {
      return store.getters[COMPANY_MODULE_NAME + "/" + COMPANY_SELF];
    },
    loginLogo() {
      if (this.company == null) {
        return "";
      }

      // Mevcut domain'in subdomain kısmını al (örn: softest.zorunluegitimler.com -> softest)
      const currentHostname = window.location.hostname;
      const currentSubdomain = currentHostname.split('.')[0];
      const companyDomain = this.company.domain;

      // Eğer mevcut subdomain alt kurumun kendi domain'i ile eşleşiyorsa
      // (örn: softest.zorunluegitimler.com -> softest === company.domain)
      // alt kurum logosu göster
      if (companyDomain && currentSubdomain === companyDomain) {
        return this.company.logo_link || "";
      }

      // Aksi halde (admin tarafından alt kuruma geçiş yapılmışsa, yani üst kurum domain'i kullanılıyorsa)
      // üst kurum logosu göster
      return this.company.parent?.logo_link || this.company.logo_link || "";
    },
    isAzal() {
      return this.company?.alias === "skyacademy";
    },
    userInfo() {
      return this.authUser;
    },
    isChatDisabled() {
      const chatSettings = this.company?.settings?.find(
          (x) => x.key === "chat_is_disabled"
      );

      // chat_is_disabled tanımlanmamışsa false döndür
      if (chatSettings?.value === undefined || chatSettings?.value === null) {
        return false;
      }

      // chat_is_disabled true ise gizle
      return chatSettings.value === true || chatSettings.value === 1;
    },
    hideOnlineUser() {
      const hideOnlineUser = this.company?.settings?.find(
          (x) => x.key === "hide_online_users"
      );

      // chat_is_disabled tanımlanmamışsa false döndür
      if (
          hideOnlineUser?.value === undefined ||
          hideOnlineUser?.value === null
      ) {
        return false;
      }
      // chat_is_disabled true ise gizle
      return hideOnlineUser.value === true || hideOnlineUser.value === 1;
    },
  },
  methods: {
    showUser() {
      this.$refs.onlineUsersModal.show();
    },
    superAdmin() {
      if (this.user_header === null || !("roles" in this.user_header)) {
        return false;
      }
      if (this.user_header.roles.length > 2) {
        return true;
      } else {
        return false;
      }
    },
    leaveFromUser() {
      axios
          .delete("api/impersonate/leaving", {
            headers: this.apiHeaders,
          })
          .then((response) => {
            if (this.superAdminToken) {
              ls.set("token", this.superAdminToken);
              window.localStorage.removeItem("superAdminToken");
              location.reload();
            }
          });
    },
    getNotifCount() {
      let self = this;

      self.$store.dispatch(
          NOTIFICATION_MODULE_NAME + "/" + NOTIFICATION_GET_COUNT,
          {}
      );
    },
    searchResults(val) {
      const search = (val || "").trim();
      if (!search) return;
      if (this.$route.name !== "User.search") {
        this.$router.push({ name: "User.search", query: { search } });
      } else {
        this.$router.push({ name: "User.search", query: { ...this.$route.query, search } });
      }
    },
    closeDropdown(route, refName, params = {}) {
      if (refName === "messageRefs") {
        params = _.merge({}, { message: params });
        this.getMessagesCount();
      }
      if (this.$route.name != route) {
        this.$router.push({ name: route, params: params });
      }
      // Component ref ise içindeki dropdown element'ini bul
      const ref = this.$refs[refName];
      if (ref) {
        const el = ref.$refs && ref.$refs[refName] ? ref.$refs[refName] : ref.$el || ref;
        UIkit.dropdown(el).hide(0);
      }
    },
    onLogout() {
      // Kanaldan çık
      if (window.Echo && this.userInfo?.company_id) {
        try {
          window.Echo.leave(`online-users-${this.userInfo.company_id}`);
        } catch (e) {
          console.warn('Channel leave error:', e);
        }
      }
      if (window.Echo && this.userInfo?.id) {
        try {
          window.Echo.leave(`point-channel-${this.userInfo.id}`);
        } catch (e) {
          console.warn('Channel leave error:', e);
        }
      }
      // Client tarafında onlineUsers listesinden kendini çıkar
      if (this.onlineUsers && this.userInfo) {
        const users = this.onlineUsers.filter(u => u.user !== this.userInfo.id);
        this.$set(this, 'onlineUsers', users);
        this.$store.commit(COMPANY_MODULE_NAME + '/' + SET_ONLINE_USERS, users);
      }

      // Socket bağlantısını güvenli şekilde kapat
      if (window.Echo && window.Echo.connector && window.Echo.connector.socket?.readyState === WebSocket.OPEN) {
        window.Echo.disconnect();
      }

      window.localStorage.removeItem("redirect_url");
      this.$store.dispatch(LOGOUT).then(() => this.$router.push({ name: "login" }));
    },
    fixDateToNow(value) {
      return moment(value)
          .locale(this.secureLocalStorage("language"))
          .format("DD MMMM YYYY");
    },
    getNotificationItems() {
      let self = this;

      self.$store.dispatch(
          NOTIFICATION_MODULE_NAME + "/" + NOTIFICATION_GET_ITEMS,
          {
            filters: {
              limit: 10,
            },
          }
      );
    },

    getMessages() {
      // Chat devre dışıysa mesajları almayı atla
      if (this.isChatDisabled) {
        this.messageItems = [];
        return;
      }

      let self = this;
      self.$store
          .dispatch(GET_ITEMS, {
            url: this.messagesUrl,
            filters: {},
            acceptPromise: false,
          })
          .then((response) => {
            let items = response.data;
            items.forEach((item) => {
              let chatUsers = item.group.users;
              item.user = chatUsers.find(
                  (subItem) => subItem.id === item.sender_user_id
              );
            });
            self.messageItems = items;
          });
    },
    getMessagesCount() {
      // Chat devre dışıysa mesaj sayısını almayı atla
      if (this.isChatDisabled) {
        this.itemCount = 0;
        return;
      }

      let self = this;
      self.$store
          .dispatch(GET_ITEMS, {
            url: this.messagesCountUrl,
            filters: {},
            acceptPromise: false,
          })
          .then((response) => {
            self.itemCount = response.data;
          });
    },
    async getCompanyItem() {
      try {
        const response = await this.$store.dispatch(
            `${COMPANY_MODULE_NAME}/${COMPANY_GET_SELF}`,
            { url: COMPANY_SELF_URL }
        );

        subCompany.value = response.children;
        subCompany.value?.unshift({
          name: JSON.parse(ls.get("parentCompany"))?.company_name,
          id: JSON.parse(ls.get("parentCompany"))?.company_id,
        });

        getSubCompanyId.value = getInitialSubDomainId();

        const root = document.querySelector(":root");
        const settings = response?.settings?.find(
            (x) => x.key === "theme_settings"
        )?.value;

        const defaultColors = {
          iconColor: "#93949c",
          infoColor: "#00b8d9",
          backgroundColor: "#666CFF",
          primaryColor: "#3F51B5",
          secondaryColor: "#eff2f7",
          dangerColor: "#EC5252",
          successColor: "#36b37e",
          warningColor: "#ffab00",
        };

        Object.entries(defaultColors).forEach(([key, defaultValue]) => {
          root.style.setProperty(`--${key}`, settings?.[key] || defaultValue);
        });

        // company bilgisi varsa title güncelle
        if (this.company?.name && !this.company?.logo_link) {
          document.title = this.company.name;
        }
      } catch (error) {
        console.error("getCompanyItem error:", error);
      }
    },
  },
  notifications: {
    showPointMessage: {
      title: "Tebrikler",
      message: "1 puan kazandınız.",
      type: "success",
      position: "topRight",
    },
  },
  mounted() {
    this.superAdminToken = ls.get("superAdminToken");

    // Önce company bilgilerini al, sonra mesaj işlemlerini yap
    this.getCompanyItem().then(() => {
      this.getMessages();
      this.getMessagesCount();
    });

    this.getNotificationItems();
    this.getNotifCount();

    EventBus.$on("message_count", () => {
      if (!this.isChatDisabled) {
        this.getMessagesCount();
      }
    });

    let EchoServer = new Echo({
      broadcaster: "socket.io",
      host: process.env.VUE_APP_WEBSOCKET_URL,
      auth: {
        headers: {
          Authorization: "Bearer " + this.secureLocalStorage("token"),
          Company: getSubCompanyId?.value,
        },
      },
      forceTLS: false,
      disableStats: true,
      encrypted: false,
      enabledTransports: ["ws", "wss"],
    });

    let EchoServer2 = new Echo({
      broadcaster: "socket.io",
      host: process.env.VUE_APP_WEBSOCKET_URL,
      auth: {
        headers: {
          Authorization: "Bearer " + this.secureLocalStorage("token"),
          Company: getSubCompanyId?.value,
        },
      },
      forceTLS: false,
      disableStats: true,
      encrypted: false,
      enabledTransports: ["ws", "wss"],
    });

    if (this.userInfo && this.userInfo.company_id) {
      const channelName = `online-users-${this.userInfo.company_id}`;

      // Online kullanıcıları dinle
      EchoServer.join(channelName)
          // O anda online olanlar
          .here((users) => {
            const onlineUsers = _.uniqBy(_.values(users), "user");
            this.$set(this, "onlineUsers", onlineUsers);
            this.$store.commit(
                COMPANY_MODULE_NAME + "/" + SET_ONLINE_USERS,
                onlineUsers
            );
          })
          // Yeni biri online oldu
          .joining((user) => {
            let users = _.values(this.onlineUsers || []);
            users.push(user);
            users = _.uniqBy(users, "user");
            this.$set(this, "onlineUsers", users);
            this.$store.commit(
                COMPANY_MODULE_NAME + "/" + SET_ONLINE_USERS,
                users
            );
          })
          // Biri offline oldu
          .leaving((user) => {
            let users = _.values(this.onlineUsers || []);
            users = users.filter((u) => u.user !== user.user);
            this.$set(this, "onlineUsers", users);
            this.$store.commit(
                COMPANY_MODULE_NAME + "/" + SET_ONLINE_USERS,
                users
            );
          });

      // Özel channel (point event)
      EchoServer2.private(`point-channel-${this.userInfo.id}`).listen(
          "point-event",
          (data) => {
            this.showPointMessage(data.message);
          }
      );
    }
  },

  watch: {
    $route(to, from) {
      // Notification dropdown'ı kapat
      if (this.$refs.notificationDropdown) {
        this.$refs.notificationDropdown.hide();
      }

      // Profile dropdown'ı kapat
      if (this.$refs.profileDropdown) {
        this.$refs.profileDropdown.hide();
      }

      // Chat devre dışı değilse messageRefs'i de kapat
      if (!this.isChatDisabled && this.$refs.messageRefs) {
        this.$refs.messageRefs.hide();
      }
    },
  },
};
</script>

<style lang="scss" src="./header.scss"></style>
